export default __webpack_public_path__ + "static/media/AWAYPM-dark.fb0e8e84.svg";